
<template>
  <div>
    <v-container class="text-center mt-10">
      <h1>Verifikasi WhatsApp dan</h1>
      <h1>Meminta Admin DPMPTSP untuk mengaktifkan Akun</h1>
      <p class="mt-10">
        Silakan tekan tombol di bawah untuk verifikasi nomor WhatsApp Anda.
      </p>
      <div CLASS>
        <v-btn color="primary" @click="submit">Meminta Aktivasi</v-btn>
      </div>
      <p class="mt-10 font-italic">Pastikan Nomor Whatsapp Anda Benar</p>
    </v-container>
  </div>
</template>

<script>
import UserService from "@/services/user-service";
import User from "@/models/user";
import FUmkmService from "@/services/apiservices-umkm/f-umkm-service";
import CryptoJS from "crypto-js";

export default {
  name: "VerifikasiLoginLinkView",
  components: {},
  data() {
    return {
      timeMilis: 0,
      requestId: 0,
      itemModified: new User("", ""),
    };
  },
  methods: {
    submit() {
      this.itemModified.remark1 = "*WhatsApp Verified#";
      this.itemModified.isAccountNonLocked = 1;
      UserService.updateUserRemark1(this.itemModified).then(
        () => {
          this.createNewUmkmObject(this.itemModified);
          this.$router.push("/verifikasi-login-link-send");
        },
        (error) => {
          console.log(error);
        }
      );
    },
    createNewUmkmObject(user) {
      const fumkm = {
        id: 0,
        userBean: user.id,
        fdivisionBean: user.fdivisionBean,
      };

      FUmkmService.createFUmkmEmptyPublic(fumkm).then(
        () => {
          console.log("New UMKM Object Created");
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
  created() {
    const encryptedTimeOut = this.$route.params.encryptedTimeOut;
    const encryptedUserId = this.$route.params.encryptedUserId;
    const key = CryptoJS.enc.Utf8.parse("Welcome1DESGREEN");

    // Decrypt timeOut
    const decryptedTimeOutBytes = CryptoJS.AES.decrypt(encryptedTimeOut, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    this.timeMilis = decryptedTimeOutBytes.toString(CryptoJS.enc.Utf8);

    // Decrypt userId
    const decryptedUserIdBytes = CryptoJS.AES.decrypt(encryptedUserId, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    this.requestId = decryptedUserIdBytes.toString(CryptoJS.enc.Utf8);
    this.itemModified.id = decryptedUserIdBytes.toString(CryptoJS.enc.Utf8);
  },
  mounted() {
    // UserService.getUserById(this.requestId).then(
    //     response =>{
    //       this.itemModified = response.data;
    //     },
    //     error =>{
    //       console.log(error)
    //     }
    // )
  },
};
</script>

<style scoped>
</style>